var _g, _path, _g2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroup22(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 909,
    height: 119,
    viewBox: "0 0 909 119",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_569_847)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.251831,
    y: 0.402344,
    width: 904.048,
    height: 112.85,
    rx: 5.91405,
    fill: "url(#paint0_linear_569_847)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.251831 6.3164C0.251831 3.05015 2.89964 0.402344 6.16588 0.402344H12.8812V113.252H6.16588C2.89964 113.252 0.251831 110.604 0.251831 107.338V6.3164Z",
    fill: "white",
    fillOpacity: 0.3
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    clipPath: "url(#clip0_569_847)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M803.439 170.118L667.153 2.33398H626.013L762.209 170.118H803.439Z",
    fill: "url(#paint1_linear_569_847)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M746.441 170.118L610.155 2.33398H587.138L723.425 170.118H746.441Z",
    fill: "url(#paint2_linear_569_847)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_569_847",
    x: 0.251831,
    y: 0.402344,
    width: 908.6,
    height: 118.401,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 3.96,
    dy: 4.96
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.295703
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_569_847"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_569_847",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_569_847",
    x1: 0.251831,
    y1: 8.19022,
    x2: 825.578,
    y2: 279.106,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.351666,
    stopColor: "#2B978E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#27B872"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_569_847",
    x1: 737.505,
    y1: 129.217,
    x2: 609.191,
    y2: -111.34,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501576,
    stopColor: "#F7EBEB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_569_847",
    x1: 700.126,
    y1: 149.155,
    x2: 571.812,
    y2: -91.4026,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.493062,
    stopColor: "#F7EBEB"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_569_847"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 216.481,
    height: 97.9863,
    fill: "white",
    transform: "translate(586.67 2.49414)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup22);
export default __webpack_public_path__ + "static/media/Group22.d98506bd8b3cbd0e0c6ea6652b47764b.svg";
export { ForwardRef as ReactComponent };